import { render, staticRenderFns } from "./MyInformations.vue?vue&type=template&id=63720c58&"
import script from "./MyInformations.vue?vue&type=script&lang=js&"
export * from "./MyInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports